import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PHOTO_REVIEW_UISTATE } from '../model/photo-review.constant';

@Component({
	selector: 'cv-photo-base-content',
	templateUrl: './photo-card-base-content.component.html',
	styleUrls: ['./photo-card-tab-content.component.scss'],
})
export class PhotoBaseContentComponent implements OnInit {
	tabs = PHOTO_REVIEW_UISTATE;
	hasPointer: boolean;
	@Input() info: any;
	@Input() contentType: string;
	@Output() getCardContent: EventEmitter<any> = new EventEmitter<any>();

	/**
	 * emits the card informations when its selected
	 */
	selectedCard(): void {
		if (this.contentType === this.tabs.TAB_TITLES.INTERIOR) {
			const { interiorDeficiencies }: any = this.info;
			this.getCardContent.emit(interiorDeficiencies);
		}
	}
	ngOnInit(): void {
		this.hasPointer = this.contentType === this.tabs.TAB_TITLES.INTERIOR;
	}
}
